<template>
	<div class="border-top">
		<SOFilterTitle :title="title" :diterapkan="diterapkan" :id="id"/>
		<div class="p-l-24 p-r-24 p-d-24" v-show="false" :id="id">
			<SOInputSelect
                v-if="withOption"
				class="m-d-16"
				:title="'Berdasarkan'"
				:selected="optionSelected"
				:placeholder="'Pilih layanan berdasarkan'"
				:options="optionData"
				@option-selected="selectedBerdasarkan"
			/>

			<SOInputSelectMultiple
				:title="'Layanan'"
				:label="'title'"
				:placeholder="'Ketik untuk menambahkan...'"
				:track-by="'id'"
				:options="layanan.data"
				:multiple="true"
				:searchable="true"
				:value="selectedLayananData"
				@selected="selectedLayanan"

				:async="true"
				:is-loading="pageSetting.loading"
				@get-async-data="getLayananOwner"
			/>
		</div>
	</div>
</template>

<script>
import {mapGetters} from "vuex"
import SOFilterTitle from "@/so-components/global/filter/base/SOFilterTitle";
import SOInputSelect from "@/so-components/global/input/SOInputSelect";
import SOInputSelectMultiple from "@/so-components/global/input/SOInputSelectMultiple";

export default {
	name: "SOFilterLayananOwner",
	components: {
		SOFilterTitle,
		SOInputSelect,
		SOInputSelectMultiple,
	},
	props: {
		id: String,
		withOption: {
			type: Boolean,
			default: false,
		},
		optionData: {
			type: Array,
			default: [],
		},
		optionSelected: {
			type: String,
			default: "",
		},
        title: {
            type: String,
            default: "Layanan"
        }
	},
	computed: {
		...mapGetters("filterGlobalModule", {
			filterItem: "getFilterItem",
		}),
		...mapGetters("layananModule", {
			listLayanan: "getListLayananOwner",
		})
	},
	data() {
		return {
			layanan: {
				name: "layanan-owner",
				data: []
			},
			selectedLayananData: [],
			pageSetting: {
				loading: true,
			},
			diterapkan: false
		}
	},
	async mounted() {
		// await this.getLayananOwner()
		await this.setSelectedData()
		this.diterapkan = this.filterItem.layananOwner.length > 0
	},
	watch: {
		"filterItem.layananOwner": {
			handler: function () {
				this.diterapkan = this.filterItem.layananOwner.length > 0
			}
		}
	},
	methods: {
		async getLayananOwner(key) {
			this.layanan.data = []
			let temp = this.filterItem
			// temp.layananOwner = []
			this.$store.commit("filterGlobalModule/setFilterItem", temp)

			this.pageSetting.loading = true
			this.layanan.data = []
			const res = await this.$store.dispatch("layananModule/fetchListLayananOwner", key)
			this.pageSetting.loading = false
			if (!res.success) {
				this.$toast.error(res.err)
				return
			}

			this.listLayanan.data.forEach(data => {
				this.layanan.data = [...this.layanan.data, {
					id: "flo-" + data.idlayanan + "-" + data.idoutlet,
					value: data.idlayanan,
					title: data.nama_layanan,
					subtitle: "Outlet " + data.nama_outlet,
				}]
			})
		},
		async setSelectedData() {
			if (this.filterItem.layananOwner.length > 0) {
				for (let i = 0; i < this.filterItem.layananOwner.length; i++) {
					await this.getLayananOwner(this.filterItem.layananOwner[i])
					this.selectedLayananData = [...this.selectedLayananData, this.layanan.data[0]]
				}
			}
			this.pageSetting.loading = false
		},
		selectedBerdasarkan(val) {
			let temp = this.filterItem
			temp.filterLayananOwner = val
			this.$store.commit("filterGlobalModule/setFilterItem", temp)
		},
		selectedLayanan(val) {
			let selected = []
			val.forEach(v => {
				selected = [...selected, v.value]
			})

			let temp = this.filterItem
			temp.layananOwner = selected
			this.$store.commit("filterGlobalModule/setFilterItem", temp)
			this.diterapkan = this.filterItem.layananOwner.length > 0
		},
	},
	beforeDestroy() {
		this.$store.commit("layananModule/resetListLayananOwner")
	}
}
</script>